import React from 'react';
import { useTranslation } from 'react-i18next';

const ShippingMethodSummary = (props) => {
  const { t } = useTranslation();

  const { code, min, max, verb, unit } = props.shippingEstimate;

  const translatedUnit =
    max === 1
      ? t(`shipping.shippingEstimate.timeUnits.${unit}.one`)
      : t(`shipping.shippingEstimate.timeUnits.${unit}.other`);

  return (
    <>
      <h3>{t('checkout.summary.shippingMethod.title')}</h3>
      <p>
        {t(`checkout.shipping.method.${code}`)} (
        {min === null
          ? t(`checkout.shippingEstimate.tag.${verb}.single`, {
              max,
              time_unit: translatedUnit,
            })
          : t(`checkout.shippingEstimate.tag.${verb}.multiple`, {
              min,
              max,
              time_unit: translatedUnit,
            })}
        )
      </p>
    </>
  );
};

export default ShippingMethodSummary;
